export const publicaciones_item = [
  {
    publicaciones_item_nombre: "ANEXO 7CAF",
    publicaciones_item_url: "../Informacion/Publicaciones/Anexo7CAF/Anexo7CAF",
    publicaciones_item_leyenda: "",
  },
  {
    publicaciones_item_nombre: "Comparecencias",
    publicaciones_item_url: "../Informacion/Publicaciones/Comparecencias/Comparecencias",
    publicaciones_item_leyenda: "",
  },
  {
    publicaciones_item_nombre: "Diagnóstico Sectorial de Salud 2021",
    publicaciones_item_url: "../../contenido/informacion/publicaciones/Diagnóstico_2021.pdf",
    publicaciones_item_leyenda: "",
  },
  {
    publicaciones_item_nombre: "Diario Oficial de la Federación y Periódico Oficial del Estado de Hidalgo",
    publicaciones_item_url: "../Informacion/Publicaciones/DOFPOEH/DofPoeh",
    publicaciones_item_leyenda: "",
  }, 
  {
    publicaciones_item_nombre: "Informe de Resultados del Programa Anual de Desarrollo Archivístico (PADA)",
    publicaciones_item_url: "../Informacion/Publicaciones/IRPADArchivisticoSESA/IRPADArchivisticoSESA",
    publicaciones_item_leyenda: "Secretaría de Salud (PADA)",
  },
  {
    publicaciones_item_nombre: "Informe de Resultados del Programa Anual de Desarrollo Archivístico (PADA)",
    publicaciones_item_url: "../Informacion/Publicaciones/IRPADArchivisticoSSH/IRPADArchivisticoSSH",
    publicaciones_item_leyenda: "Servicios de Salud (PADA)",
  },
  {
    publicaciones_item_nombre: "PID del Régimen Estatal de Protección Social en Salud 2017-2022",
    publicaciones_item_url: "../../contenido/informacion/publicaciones/011_PID Régimen Estatal de Protección Social en Salud de Hidalgo.pdf",
    publicaciones_item_leyenda: "",
  },
  {
    publicaciones_item_nombre: "Población de Responsabilidad",
    publicaciones_item_url: "../Informacion/Publicaciones/poblaResponsabilidad/poblaResponsabilidad",
    publicaciones_item_leyenda: "",
  },
  {
    publicaciones_item_nombre: "Población por Municipio con Unidades Médicas SSH",
    publicaciones_item_url: "../Informacion/Publicaciones/poblaMunicipio/poblaMunicipio",
    publicaciones_item_leyenda: "",
  },
  {
    publicaciones_item_nombre: "Programa Anual de Desarrollo Archivístico (PADA)",
    publicaciones_item_url: "../Informacion/Publicaciones/PADArchivisticoSESA/PADArchivisticoSESA",
    publicaciones_item_leyenda: "Secretaría de Salud (PADA)",
  },
  {
    publicaciones_item_nombre: "Programa Anual de Desarrollo Archivístico (PADA)",
    publicaciones_item_url: "../Informacion/Publicaciones/PADArchivisticoSSH/PADArchivisticoSSH",
    publicaciones_item_leyenda: "Servicios de Salud (PADA)",
  },
  {
    publicaciones_item_nombre: "Programa Institucional de Desarrollo SSH",
    publicaciones_item_url: "../Informacion/Publicaciones/Comparecencias/Pid",
    publicaciones_item_leyenda: "",
  },
  {
    publicaciones_item_nombre: "Programa Sectorial de Salud",
    publicaciones_item_url: "../Informacion/Publicaciones/Comparecencias/Pss",
    publicaciones_item_leyenda: "",
  }, 
];
